export default __webpack_public_path__ + "static/media/howtouse_plus_05_02_en.71395569.png";